import { useFilters } from 'hooks/useQuery'
import { sortBy } from 'lodash'
import { useLoadTemplates } from 'queries/templates/useLoadTemplates'
import React from 'react'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import PageTitle from 'ui/molecules/PageTitle'

import Pagination from '@/ui/atoms/Pagination'

import Api from '../api'
import Spinner from '../components/Spinner'
import ui from '../ui'

export default function TemplatesPage() {
  const { filters } = useFilters({ defaultValues: { page: 1, pageSize: 25 } })
  const { data, isLoading, isFetching } = useLoadTemplates(filters)
  const [importLoading, setImportLoading] = React.useState(false)
  const [importingTemplateId, setImportingTemplateId] = React.useState(null)

  const loading = isLoading || isFetching || importLoading
  const formTemplates = sortBy(data?.results || [], 'name')

  async function importBtn(id) {
    setImportLoading(true)
    setImportingTemplateId(id)
    try {
      await Api.postTemplate(id)
      toast.success('Form imported successfully')
    } catch (error) {
      toast.error('Error importing form')
    }
    setImportLoading(false)
    setImportingTemplateId(null)
  }

  function previewBtn(id) {
    window.open(`/r/template/preview/${id}`, '_blank')
  }

  return (
    <>
      <Helmet>
        <title>Templates/Zentake</title>
      </Helmet>
      <div className="relative mx-auto mt-6 max-w-screen-xl md:px-3">
        <PageTitle
          subText="Import any form template into your account."
          text="Templates"
        />
        <div className="sm:flex sm:space-x-4">
          <ui.SearchBar className="mb-4 flex-1" />
        </div>
        <div className="mx-auto max-w-screen-xl pb-2">
          <div className="relative mb-10 border border-gray-400 bg-white md:rounded">
            <div className="flex w-full items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-3 text-xs font-medium uppercase leading-4 tracking-wider text-gray-500">
              <span>Form name</span>
            </div>
            {formTemplates.map((item) => (
              <div
                className="block border-b border-gray-200 transition duration-150 ease-in-out hover:bg-gray-50 hover:no-underline focus:bg-gray-50 focus:outline-none"
                key={item.id}
              >
                <div className="flex items-center space-x-2 px-4 py-4 sm:px-6">
                  <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                    <div className="tex-blue-600 truncate text-sm font-medium leading-5">
                      {item.name}
                    </div>
                    <div className="flex items-center">
                      <ui.PrimaryButton
                        className="mr-1.5 h-10 rounded border-gray-600 bg-white"
                        disabled={loading}
                        onClick={() => previewBtn(item.id)}
                      >
                        <span className="text-gray-700">Preview</span>
                      </ui.PrimaryButton>
                      <ui.PrimaryButton
                        className="mr-1.5 h-10 rounded border-gray-600 bg-white"
                        disabled={loading}
                        onClick={() => importBtn(item.id)}
                      >
                        {loading && importingTemplateId === item.id && (
                          <Spinner color="onLight" size={30} />
                        )}
                        <span className="text-gray-700">Import</span>
                      </ui.PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <Pagination total={data?.count || 0} />
          </div>
        </div>
      </div>
    </>
  )
}
